module.exports = __webpack_public_path__ + "static/media/veranda-login-banner2.ff0862ff.jpg";